@if (purchaseRequisition) {
  <!-- container-fluid pays the gutter of the row below; the task forms embed this view without one -->
  <div class="container-fluid">
    @if (!task) {
      <purchase-requisition-task-hint
        [demandId]="purchaseRequisition.demand.id"
      ></purchase-requisition-task-hint>
    }
    <div class="row">
      <div class="col">
        @if (purchaseRequisition.demand) {
          <demand-content
            [purchaseRequisition]="purchaseRequisition"
            [editingWithDialog]="editingWithDialog"
            [history]="history"
            [supplierRequired]="supplierRequired"
            [supplierChangeAllowed]="supplierChangeAllowed"
            [validUntilRequired]="validUntilRequired"
            [task]="task"
            (validationStatusChange)="setValid($event)"
            (withdrawn)="withdraw()"
            (suppliersChanged)="supplierChanged.emit($event)"
            (currencyAcceptanceChanged)="currencyAcceptanceChanged.emit($event)"
            (initialized)="initialized.emit()"
            #demandContentComponent
            >
            <ng-content></ng-content>
          </demand-content>
        }
      </div>
    </div>
  </div>
}
